module.exports = __webpack_public_path__ + "static/img/autobg2.d05b3b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/logo/autobg2.png
// module id = u5wF
// module chunks = 69